this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
// let cartTotalValue = Number(document.querySelector('.totals__subtotal-value').getAttribute('value'));
 let cartDrawer2 = document.querySelector('cart-drawer.drawer');

checkIfPouchExistsInCart();
if(document.getElementById('pouch__user-add-submit-button')) {
  document.getElementById('pouch__user-add-submit-button').addEventListener('click', addPouchAddon);
}

function updateCartDrawerProgressBar() {
  /* Progress Bar - Cart Drawer */
  const cartAlert = document.querySelector('.cart-alert');
  if(cartAlert) {
    const goalValue = document.querySelector('.cart-alert').getAttribute("metafield-goal-value");
    let cartSubtotalValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value").getAttribute('value');
    let goalRemainingValue = goalValue - cartSubtotalValue;
    goalRemainingValue = Number(goalRemainingValue).toFixed(2);

    if(goalRemainingValue > 0) {
      document.querySelector('.cart-alert__remaining-message').classList.remove('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.add('hidden');
      document.querySelector('.cart-alert__goal-calc').innerHTML = `$${goalRemainingValue}`;
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue - goalRemainingValue);
      document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$8'
    } else {
      document.querySelector('.cart-alert__remaining-message').classList.add('hidden');
      document.querySelector('.cart-alert__qualify-message').classList.remove('hidden');
      document.querySelector('.cart-alert__progress-bar').setAttribute('value', goalValue);
      document.querySelector('.cart-drawer__estimated-shipping').innerHTML = '$0'
    }

    window.Klarna.OnsiteMessaging.refresh();
    
    let cartDrawerWishlist = document.querySelectorAll('#CartDrawer .quick-add-wishlist');
    cartDrawerWishlist.forEach(function(item) {
      item.remove();
    });

    let cartDrawerBlackFridaySale = document.querySelectorAll('#CartDrawer .global-discount__savings');
    if(cartDrawerBlackFridaySale) {
      cartDrawerBlackFridaySale.forEach(function(item) {
        item.remove();
      });
    }
    
    const scrollbarVisible = (element) => {
      return element.scrollHeight > element.clientHeight;
    }
    const cartDrawerContainer = document.querySelector('cart-drawer-items')
        
    if(scrollbarVisible(cartDrawerContainer) === true) {
      document.querySelector('.cart-drawer .drawer__cart-items-wrapper').style.marginRight = '1rem';
      document.querySelector('.cart-drawer .cart-alert').style.marginRight = '1rem';
      document.querySelector('.cart-drawer .slider-button--next').style.marginRight = '1rem';
    }
  }
}

function addPouchAddon(evt) {
  evt.preventDefault();
  this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  this.form = document.getElementById('pouch__user-add-submit-form');
  // const selectedVariant = this.form.querySelector('[name=id]').value;

  fetch('/cart.js')
  .then((response) => response.json())
  .then((responseText) => {
    this.setAttribute('aria-disabled', true);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append('id', pouchProduct.pouchProductInformation.variants[0].id);
    formData.append('quantity', '1');
    formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
    formData.append('sections_url', window.location.pathname);

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      this.cart.getSectionsToRender().forEach((section => {
      const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML =
      getSectionInnerHTML(response.sections[section.section], section.selector);
      document.getElementById('jewelryPouchAddon').classList.add('hidden');
      }));

      fetch('/cart.js')
      .then((response) => response.json())
      .then((responseText) => {
        document.querySelector('.drawer__inner').setAttribute('value', responseText.item_count);
        updateCartDrawerProgressBar();
        cartDrawer2.classList.toggle('is-empty', responseText.item_count === 0);
      })

    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (!this.error) this.removeAttribute('aria-disabled');
      document.getElementById('pouch__user-add-submit-form').addEventListener('click', addPouchAddon);
    });
  });
}

function checkIfPouchExistsInCart() {
  fetch('/cart.js')
  .then((response) => response.json())
  .then((responseText) => {
    if(responseText.items.some(function(el) { return el.product_title === 'Alicia Chain Hoop Earrings' }) == false) {
      document.getElementById('jewelryPouchAddon').classList.remove('hidden');
    } else {
      document.getElementById('jewelryPouchAddon').classList.add('hidden');
    }
  });
}

function getSectionInnerHTML(html, selector = '.shopify-section') {
  return new DOMParser()
  .parseFromString(html, 'text/html')
  .querySelector(selector).innerHTML;
}